import { SamplingUploadedFile } from 'src/shared/types/sampling';
import { CustomFile } from 'src/shared/types/update';
import {
  DomainUploadedFile,
  UploadedFile
} from 'src/shared/types/uploadedFile';

const isFileImage = (
  file:
    | File
    | UploadedFile
    | CustomFile
    | SamplingUploadedFile
    | DomainUploadedFile
) => {
  if ('content_type' in file) {
    return file.content_type?.startsWith('image');
  }

  if ('url' in file) {
    const imageExtensions = [
      '.jpg',
      '.jpeg',
      '.png',
      '.gif',
      '.bmp',
      '.webp',
      '.svg'
    ];
    const url = file?.url as string;
    const lowerCased = url.toLowerCase();

    return imageExtensions.some((ext) => lowerCased.endsWith(ext));
  }

  return false;
};

export default isFileImage;
